import { z } from 'zod';

import { ComponentDefinition } from '../../types/ComponentDefinition';
import { ComponentPayloadValidator, ComponentValidator } from '../Component';
import { AbstractPort, Port } from '../fields/AbstractPort';

const port = AbstractPort.extend({
    AC: Port.AC.extend({
        controlMethods: Port.controlMethods.validator,
    }).default({}),
    DC: Port.DC.extend({
        controlMethods: Port.controlMethods.validator,
    }).default({}),
    capacitance: Port.capacitance.validator,
    reverseDiode: z.boolean().default(false),
    equivalentSeriesResistance: Port.equivalentSeriesResistance.validator,
    powerFlowDirection: Port.powerFlowDirection.literals.input,
}).default({});

const LoadBase = z.object({
    type: z.literal('load').default('load'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const LoadValidator = ComponentValidator.merge(LoadBase);
export const LoadPayloadValidator = ComponentPayloadValidator.merge(LoadBase);

export const LoadDefinition: ComponentDefinition = {
    type: 'load',
    name: 'Load',
    plural: 'Loads',
    indicator: 'LOAD',
    allowCustomIcon: true,
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: true,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input'],
        allowedControlMethods: ['constant-power', 'power-voltage'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: LoadValidator,
        payload: LoadPayloadValidator,
    },
};

export type Load = z.infer<typeof LoadValidator>;
export type LoadPayload = z.infer<typeof LoadPayloadValidator>;
